import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { GetEssayAnswers } from "../api/Quiz/GetEssayAnswers";
import Navbar from "../components/Layout/Navbar";
import Spinner from "../components/Shared/Spinner";

const EssayQuizAnswers = () => {
  const { quizId, num_trial } = useParams<{ quizId: string; num_trial: string }>();
  const numTrial = num_trial ? parseInt(num_trial) : 0;

  const { data, isLoading } = useQuery({
    queryFn: () => GetEssayAnswers(quizId || ""),
    queryKey: ["essayAnswers", quizId],
    staleTime: 0,
    enabled: !!quizId,
    // Fresh on mount, never in the background; see QuizAnswers.tsx.
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const attempt = data?.data?.quizDetails.find((a) => a.num_tries === numTrial);
  const quizTitle = data?.data?.quizTitle;

  if (isLoading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );

  if (!attempt)
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-20">
          <p className="text-gray-500 text-lg">Attempt not found.</p>
        </div>
      </>
    );

  return (
    <>
      <Navbar />
      <div className="bg-white w-full min-h-screen py-28">
        <div className="container">
          <h1 className="font-bold text-burntBlack text-2xl md:text-3xl mb-2">
            {quizTitle}
          </h1>
          <p className="text-lightGray mb-6">Attempt #{attempt.num_tries}</p>

          <div className="sm:w-[472px] py-[18px] px-6 mb-8">
            <div className="flex gap-8 justify-between font-bold md:text-2xl text-lg">
              <div>
                <p className="mb-2.5 sm:mb-5">Score</p>
                <p>Status</p>
              </div>
              <div>
                <p className="text-primary mb-2.5 sm:mb-5">{attempt.score}%</p>
                <p className={attempt.status === "passed" ? "text-green-500" : "text-red-500"}>
                  {attempt.status}
                </p>
              </div>
            </div>
          </div>

          <div className="mt-4 space-y-10">
            {attempt.question.map((q, index) => (
              <div key={index} className="border border-black/10 rounded-xl p-6">
                <h2 className="font-bold text-lg md:text-xl mb-4">
                  Q{index + 1}. {q.question}
                </h2>
                <p className="text-sm text-lightGray mb-1 font-semibold">Your Answer:</p>
                <p className="text-base">{q.explanation || "—"}</p>
              </div>
            ))}
          </div>

          <button
            onClick={() => window.close()}
            className="mt-10 text-primary underline text-sm cursor-pointer"
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
};

export default EssayQuizAnswers;
